import {
  isSimpleSelection,
  isFrame,
  hasFrameBehaviors,
} from '../objects/guards';
import Tool, { type IToolActionInput } from './Tool';

class ToolExportSelectionPNG extends Tool {
  static toolName = 'Export selection to PNG';

  static action({ controller, selection }: IToolActionInput) {
    const canvas = controller.canvas;
    const usedRect = canvas.rectContainingObjects([selection]);
    const filter = (obj: fabric.Object) => {
      let isInSelection = false;

      if (isSimpleSelection(selection)) {
        isInSelection = selection.objectInSelection(obj);
      } else {
        isInSelection = obj === selection;
      }

      // If not directly in selection, check if it's inside a selected frame (recursively)
      if (!isInSelection) {
        const checkFrameContainmentRecursive = (
          selectedObj: fabric.Object
        ): boolean => {
          if (
            isFrame(selectedObj) &&
            hasFrameBehaviors(selectedObj) &&
            selectedObj.children.length > 0
          ) {
            // Check direct children
            if (selectedObj.children.includes(obj)) {
              return true;
            }
            // Recursively check nested frames
            return selectedObj.children.some(
              child => isFrame(child) && checkFrameContainmentRecursive(child)
            );
          }
          return false;
        };

        if (isSimpleSelection(selection)) {
          // Check all selected objects for frames
          isInSelection = selection._objects.some(
            checkFrameContainmentRecursive
          );
        } else {
          // Check single selection
          isInSelection = checkFrameContainmentRecursive(selection);
        }
      }

      return isInSelection;
    };

    const result = canvas.renderToPng(usedRect, { filter });

    if (!result.success) {
      controller.actionShowMessage({ message: result.error, type: 'error' });
      return;
    }

    // Create a fake link to trigger the download.
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.target = '_blank';

    a.href = result.dataUrl;

    a.download = `${controller.exportFileName}.png`;
    a.click();
    a.remove();
  }
}

export default ToolExportSelectionPNG;
